module.exports = __webpack_public_path__ + "img/va.cc8f4812.jpg";